import i18n from '@/plugins/i18n'

export const DateTimeFilter = function(value) {
  let utcTimeAsLocalTIme = new Date(value + 'Z')
  let formatedDate = i18n.d(utcTimeAsLocalTIme, 'long', i18n.locale)
  return formatedDate
}
